import { Request } from "@konv/http";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { UserStorage } from "../shared/tools/UserStorage";

export class OrderAPI {
  static async request({
    endpoint = "/",
    method = "GET",
    headers,
    query,
    data,
  }) {
    return await Request.request({
      endpoint: endpoint,
      method: method,
      headers: headers,
      service: "orders",
      ignoreVersion: true,
      params: query,
      data: data,
    });
  }

  static async requestAuthenticated({
    endpoint = "/",
    method = "GET",
    query,
    data,
  }) {
    return await OrderAPI.request({
      endpoint,
      headers: { Authorization: "Bearer " + UserStorage.getAccessToken() },
      method,
      query,
      data,
    });
  }

  static async getOrders() {
    return await OrderAPI.requestAuthenticated({
      endpoint: "/environments/" + EnvironmentStorage.getSelectedEnvironment(),
    });
  }

  static async getOrderById(orderId) {
    return await OrderAPI.requestAuthenticated({
      endpoint:
        "/environments/" +
        EnvironmentStorage.getSelectedEnvironment() +
        "/orders/" +
        orderId,
    });
  }

  static async setStatus(orderId, targetStatus) {
    return await OrderAPI.requestAuthenticated({
      endpoint: `/${orderId}/status/${targetStatus}`,
      method: "post",
    });
  }

  static async acceptOrder(orderId) {
    const environmentId = EnvironmentStorage.getSelectedEnvironment();
    return await OrderAPI.requestAuthenticated({
      endpoint: `/${orderId}/status/IN_PRODUCTION`,
      method: "put",
    });
  }

  static async postOrders(data) {
    const environmentId = EnvironmentStorage.getSelectedEnvironment();
    return await OrderAPI.requestAuthenticated({
      endpoint: `/admin/environments/${environmentId}`,
      method: "POST",
      data,
    });
  }

  static async rejectOrder(orderId) {
    const environmentId = EnvironmentStorage.getSelectedEnvironment();
    return await OrderAPI.requestAuthenticated({
      endpoint: `/${orderId}/status/REJECTED`,
      method: "put",
    });
  }

  static async dispatchOrder(orderId) {
    return await OrderAPI.requestAuthenticated({
      endpoint: `/${orderId}/dispatch`,
      method: "post",
    });
  }
}
